import {
  Avatar,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material'

import {
  CampaignBoxFragment,
  EntryCampaignRankingConnectionFragment,
} from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { useRouter } from '@/core'
import { Cell } from '@/core/architecture'

type CampaignBoxProps = {
  campaign: CampaignBoxFragment | EntryCampaignRankingConnectionFragment
  onClick?: () => void
}

export const CampaignBox: Cell<CampaignBoxProps> = ({ campaign, onClick }) => {
  const { t } = useTranslation('globalEvents')
  const { routerPages, generatePath } = useRouter()
  return (
    <ListItemButton
      sx={{
        p: 0,
        mx: 0,
        mb: 5,
      }}
      onClick={onClick}
      href={generatePath(routerPages.CampaignDetail, {
        campaignId: campaign.id,
      })}
    >
      <ListItemAvatar>
        <Avatar
          variant="square"
          sx={{
            width: 100,
            height: 64,
            borderRadius: 2,
          }}
          alt={
            'myRank' in campaign ? campaign.myRank.displayName : campaign.title
          }
          src={campaign.thumbnail?.smallUri || ''}
        />
      </ListItemAvatar>
      <ListItemText
        sx={{ pl: 4 }}
        primary={
          'myRank' in campaign ? (
            <>
              {campaign.myRank.rank}
              <Typography component="span" variant="subtitle2" display="inline">
                {t('rank')}
              </Typography>
            </>
          ) : (
            campaign.title
          )
        }
        secondary={
          'myRank' in campaign ? (
            <Stack
              component="span"
              justifyContent="space-between"
              alignItems="flex-end"
              direction="row"
            >
              <Typography variant="body1" component="span">
                {campaign.myRank.displayName}
              </Typography>
              <Typography variant="body2" component="span" color="text.hint">
                {campaign.myRank.point}pt
              </Typography>
            </Stack>
          ) : (
            ''
          )
        }
        slotProps={{
          primary: { variant: 'myRank' in campaign ? 'h2' : 'h5' },
        }}
      />
    </ListItemButton>
  )
}
